export default __webpack_public_path__ + "static/media/NotoSans_bold.12d1744c.ttf";